import dayjs from "dayjs";
import React from "react";
import Searchbar from "../../../../Helpers/Searchbar/Searchbar";

const EVENT_STATUS_COLORS = {
  urgent: "rgba(229, 57, 53, 1)",
  upcoming: "rgba(30, 136, 229, 1)",
  done: "rgba(76, 175, 80, 1)",
  pending: "rgba(235, 156, 38, 1)",
};

const MaintenanceList = ({ events }) => {
  const backgroundColor = (status) => {
    return EVENT_STATUS_COLORS[status];
  };
  const dateToString = (date) => {
    return dayjs(date).format("D MMM YYYY");
  };
  return (
    <div className="MaintenanceListLayout">
      <div className="MaintenanceListHeader">
        <Searchbar
          style="search search-dark input-group"
          path={`${process.env.PUBLIC_URL}/assets/Search.svg`}
          placeholder="Search"
          //   value={query}
          //   onChange={handleSearch}
        />
      </div>
      <div className="MaintenanceListBody">
        {events.map((event) => (
          <div
            key={event.id}
            className="MaintenanceListRow"
            style={{
              background: backgroundColor(event.data.appointment.status),
            }}
          >
            <div className="MaintenanceListRowItem">
              {event.data.appointment.title}
            </div>
            <div className="MaintenanceListRowItem">
              {dateToString(event.start)} - {dateToString(event.end)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MaintenanceList;
